import styled from 'styled-components';

interface IconProps {
  scale?: string | null;
}

const Icon = styled.img<IconProps>`
  width: ${(props) => (props.scale ? props.scale : '24px')};
  height: ${(props) => (props.scale ? props.scale : '24px')};
`;

export default Icon;
